// -----------------------------------------------------------------------------
// Main scripts
// -----------------------------------------------------------------------------

// Lazy load
// lazyLoad();

// Document ready
$(document).ready(function () {
  // Sticky header
  stickyHeader();

  // Sticky submenu
  stickySubmenu();

  // Sticky submenu with banner
  stickySubmenuBanner();

  // Menu mobile
  menuMobile();
  $(".menu-mobile__overlay").scrollbar();

  // Select language
  selectLang();

  // Height 100vh
  height100vh();

  // Slider cooperation
  // if ($(".coo-slider__captions").length > 0) {
  //   cooSliderCaptions();
  // }
  cooSlider();

  // Gallery trips
  gallerySliderTrip();

  // Slider with offers
  if ($(".offers-slider").length > 0) {
    offersSlider($(".offers-slider"));
  }

  // Slider itinerary
  itinerarySlider($(".itinerary-full"));

  // Slider accomodation
  if ($(".apartment-thumbs").length > 0) {
    accSlider();
  }

  // Counter
  counter();

  // Inquiry form
  inquiryForm();

  // Serach form
  // searchForm();

  // Menu activities
  menuActivities();

  // Filter posts
  filterPosts();
  offersFilter();

  // FAQ
  faq();

  // Itinerary
  itineraryTab();

  // Contact form subject
  subjectForm();

  // Scrollbar sections
  scrollbarSections();

  // Map with regions
  mapRegion();

  // Convert img to svg
  imgToSvg();

  // Region smooth scroll
  regionScroll();

  // Init niceselect to select filter
  // $("select").niceSelect();

  // Child pages watch for focus
  childPages();

  // Offers page update region ajax
  updateRegion();

  $('#search-input').keyup(function () {
    if ($(this).val() == '') {
        $('#search-button').prop('disabled', true);
        $('#search-button').find('.search-form__icon').addClass('disabled');
    } else {
        $('#search-button').prop('disabled', false);
        $('#search-button').find('.search-form__icon').removeClass('disabled');
    }
  }).keyup();

  if ( $('.filter-post__list--activity').length > 0 ) {
    var listHeight = $('.filter-post__list--activity').outerHeight() + 'px';
    $('.filter-post__list--region').css('height', listHeight);
  }
});

// Activities panel
activitiesPanel();

// Window resize
$(window).resize(function () {
  // Sticky submenu
  stickySubmenu();

  // Activities panel
  // activitiesPanel();
});

// Window on scroll
$(window).on("scroll", function () {
  // Sticky header
  stickyHeader();

  // Sticky submenu
  stickySubmenu();

  // Sticky submenu with banner
  stickySubmenuBanner();

  // Counter
  counter();
});
